const n = (a, r, e, t) => {
  var u;
  const g = (u = t == null ? void 0 : t.isStrict) != null ? u : !0;
  return !e && (t == null ? void 0 : t.errorMessage) !== void 0 && a.state.messages.push({
    type: g ? "error" : "warn",
    value: t.errorMessage
  }), !e && g && a.state.isValid && (a.state.isValid = !1), a.state.checkList[r] = e, Object.freeze(a);
}, d = (a) => a !== "", c = (a, r) => a.length <= r, i = (a, r) => a.length >= r, s = (a, r) => r.test(a), o = (a) => !s(a, /<(|\/|[^/>][^>]+|\/[^>][^>]+)>|(">)/i), A = (a) => s(a, /^[\+]?[0-9]?\(?[0-9]{3}\)?[-\s\.]?[0-9]{3}([-\s\.]?[0-9]{2}){2}$/), Z = (a) => s(a, /^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)+$/), f = (a) => {
  const r = s(
    a,
    /[`!@#\$%\^&\*\(\)\-_=\+\[\]{};:"\\\|,\.<>\/\?]+/
  ), e = s(a, /[a-zA-Z]+/), t = s(a, /\d+/), g = s(
    a,
    /^[0-9a-zA-Z`!@#\$%\^&\*\(\)\-_=\+\[\]{};:"\\\|,\.<>\/\?]+$/
  );
  return r && e && t && g;
}, l = (a) => {
  const r = {
    data: a,
    isValid: !0,
    messages: [],
    checkList: {}
  }, e = {
    state: r,
    guardEmpty: (t) => n(e, "guardEmpty", d(a), t),
    guardMaxLength: (t, g) => n(
      e,
      "guardMaxLength",
      c(r.data, t),
      g
    ),
    guardMinLength: (t, g) => n(
      e,
      "guardMinLength",
      i(r.data, t),
      g
    ),
    guardByRegexp: (t, g) => n(e, "guardByRegexp", s(r.data, t), g),
    guardXSS: (t) => n(e, "guardXSS", o(r.data), t)
  };
  return Object.freeze(e);
}, h = (a) => a != null, O = h, m = (a) => a !== 0, x = (a, r) => a <= r, M = (a, r) => a >= r, N = (a) => !Number.isNaN(a), L = (a) => a >= 0, y = (a, r) => {
  const [e, t] = r.sort((g, u) => g - u);
  return a >= e && a <= t;
}, E = (a) => {
  const r = {
    data: a,
    isValid: !0,
    messages: [],
    checkList: {}
  }, e = {
    state: r,
    guardZero: (t) => n(e, "guardZero", m(a), t),
    guardMax: (t, g) => n(e, "guardMax", x(r.data, t), g),
    guardMin: (t, g) => n(e, "guardMin", M(r.data, t), g),
    guardNaN: (t) => n(e, "guardNaN", N(r.data), t),
    guardNegative: (t) => n(e, "guardNegative", L(r.data), t),
    guardOutOfRange: (t, g, u) => n(
      e,
      "guardOutOfRange",
      y(r.data, [t, g]),
      u
    )
  };
  return Object.freeze(e);
}, S = (a) => a.length > 0, b = (a, r) => a.length <= r, z = (a, r) => a.length >= r, R = (a) => {
  const r = {
    data: a,
    isValid: !0,
    messages: [],
    checkList: {}
  }, e = {
    state: r,
    guardEmpty: (t) => n(e, "guardEmpty", S(a), t),
    guardMaxLength: (t, g) => n(
      e,
      "guardMaxLength",
      b(r.data, t),
      g
    ),
    guardMinLength: (t, g) => n(
      e,
      "guardMinLength",
      z(r.data, t),
      g
    )
  };
  return Object.freeze(e);
};
export {
  R as arrayGuard,
  s as guardByRegexpString,
  Z as guardEmailString,
  S as guardEmptyArray,
  d as guardEmptyString,
  h as guardExist,
  b as guardMaxLengthArray,
  c as guardMaxLengthString,
  x as guardMaxNumber,
  z as guardMinLengthArray,
  i as guardMinLengthString,
  M as guardMinNumber,
  N as guardNaNNumber,
  L as guardNegativeNumber,
  y as guardOutOfRangeNumber,
  f as guardPasswordString,
  A as guardPhoneString,
  O as guardUnspecified,
  o as guardXssString,
  m as guardZeroNumber,
  E as numberGuard,
  l as stringsGuard
};
